"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRedirect = createRedirect;
exports.casinoGameShouldRedirect = casinoGameShouldRedirect;
exports.returnNotFound = returnNotFound;
function createRedirect(to, permanent = true) {
    return (context) => {
        const locale = context.locale !== context.defaultLocale ? context.locale : "";
        const destination = to.startsWith("/") ? `${locale}${to}` : `${locale}/${to}`;
        const url = new URL(`${destination}`, `${context.req.headers.protocol}://${context.req.headers.host}`);
        return {
            redirect: {
                destination: url.pathname,
                permanent,
            },
        };
    };
}
function casinoGameShouldRedirect(context) {
    const { gameId, forFun } = context.query;
    const { jwt } = context.req.cookies;
    const hasToken = Boolean(jwt);
    const isForFun = Boolean(forFun) && forFun === "true";
    return Boolean(gameId) && !hasToken && !isForFun;
}
function returnNotFound() {
    return {
        notFound: true,
    };
}
//# sourceMappingURL=redirects.js.map